/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PractitionerStrictHttpResponse } from '../../practitioner-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PractitionerLobbyModel } from '../../models/practitioner-lobby-model';

export interface ConsumerLobbiesGet$Params {
}

export function consumerLobbiesGet(http: HttpClient, rootUrl: string, params?: ConsumerLobbiesGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerLobbyModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerLobbiesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PractitionerStrictHttpResponse<Array<PractitionerLobbyModel>>;
    })
  );
}

consumerLobbiesGet.PATH = '/Consumer/Lobbies';
